import { EasmScanConfigurationSchedulerWebComponent } from './component/EasmScanConfigurationSchedulerWebComponent';
import { WEB_COMPONENT_EASM_SCAN_CONFIGURATION_SCHEDULER } from '../../../webcomponents.constants';

export { EasmScanConfigurationSchedulerWebComponent };

window.customElements.define(
  WEB_COMPONENT_EASM_SCAN_CONFIGURATION_SCHEDULER,
  EasmScanConfigurationSchedulerWebComponent
);
